<template>
    <router-view />
</template>

<script>

</script>

<style lang="scss">
@use "@/assets/ui2/main.scss" as *;

</style>
